<template>
    <sa-page-layout ref="pgaView" :data="data" :pathResource="pathResource" :btnBackVisible="true" :btnSaveVisible="true" :titolo="data.nome" :linkback="linkback" :linkedit="linkedit" :showmolalloading="showmolalloading" class="sa-no-space">
        <template slot="table-body">
            <div class="sa-tab-scroll">
                <!-- <div style="height: 100%; overflow-y: auto"> -->
                <b-row>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Nome:</label>
                        <b-form-input v-model="data.nome" placeholder="Nome"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Tipo:</label>
                        <b-form-input v-model="data.tipo" placeholder="Tipo"></b-form-input>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note:</label>
                        <b-form-textarea v-model="data.note" placeholder="Note" rows="7"></b-form-textarea>
                    </b-col>
                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Parametro:</label>
                        <div class="text-danger">{{ jsonerror }}</div>
                        <b-form-textarea id="jsonText" v-model="data.parametro" placeholder="Parametro" rows="7"></b-form-textarea>
                        <pre>{{ prettyFormat }}</pre>
                    </b-col>
                </b-row>
            </div>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
//import moment from "moment";
import axios from "axios";
export default {
    components: { SaPageLayout },
    data() {
        return {
            pathResource: "/configparameter",
            linkback: "/configparameter",
            linkedit: null,
            showmolalloading: false,
            id: "-1",
            profili: [],
            jsonstr: "",
            jsonerror: "",
            data: {},
        };
    },
    computed: {
        prettyFormat: function () {
            let me = this;
            me.jsonerror = "";
            let jsonValue = "";
            try {
                jsonValue = JSON.parse(me.data.parametro);
            } catch (e) {
                console.log(e.message);
                me.jsonerror = JSON.stringify(e.message);
                var textarea = document.getElementById("jsonText");
                if (me.jsonerror.indexOf("position") > -1) {
                    // highlight error position
                    var positionStr = me.jsonerror.lastIndexOf("position") + 8;
                    var posi = parseInt(me.jsonerror.substr(positionStr, me.jsonerror.lastIndexOf('"')));
                    if (posi >= 0) {
                        textarea.setSelectionRange(posi, posi + 1);
                    }
                }
                console.log(me.jsonerror);
                return "";
            }
            return JSON.stringify(jsonValue, null, 2);
        },
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        me.data.id = this.$route.params.id;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;

            if (me.id === "-1") {
                me.showmolalloading = false;
            } else {
                me.showmolalloading = false;
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios.get(link + me.id).then((response) => {
                    me.data = response.data.data;
                    me.showmolalloading = false;
                });
            }
        },
        /*onSave() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathRest;
            let jsonData = JSON.stringify(me.data);

            me.$refs["sa-modal-loading"].show();
            if (me.id == "-1") {
                axios
                    .post(link, jsonData)
                    .then((response) => {
                        me.gruppo = response.data.data;
                        me.$refs["sa-modal-loading"].close();
                        me.$router.replace(me.pathRest).catch((err) => {
                            err;
                        });
                    })
                    .catch((error) => {
                        me.$refs["sa-modal-loading"].close();
                        this.$bvModal
                            .msgBoxOk(error.response.data.messaggio, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then((value) => {
                                this.boxTwo = value;
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    });
            } else {
                axios
                    .put(link + "/" + me.id, jsonData)
                    .then((response) => {
                        me.gruppo = response.data.data;
                        me.$refs["sa-modal-loading"].close();
                        me.$router.replace(me.pathRest).catch((err) => {
                            err;
                        });
                    })
                    .catch((error) => {
                        me.$refs["sa-modal-loading"].close();
                        this.$bvModal
                            .msgBoxOk(error.response.data.messaggio, {
                                title: "ATTENZIONE",
                                size: "sm",
                                okVariant: "outline-danger",
                                headerClass: "sa-msg-header-danger",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                            })
                            .then((value) => {
                                this.boxTwo = value;
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    });
            }
        },
        onBack() {
            let me = this;
            me.$router.replace(me.pathRest).catch((err) => {
                err;
            });
        },*/
    },
};
</script>
